<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'area-code',
};
</script>

<style>
</style>
